import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { CDN_BASE_URL } from "../../../config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import StoryPage from "../../../pages/mobile/StoryPage";
import Chat from "../../layout/Chat";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "350px",
  backgroundColor: "#fff",
  boxShadow: 24,
  borderRadius: 10,
  height: "70vh",
};

const Storys = ({ desktop, dealerData }) => {
  const [categories, setCategories] = useState();
  const [count, setcount] = useState(0);
  const [show, setshow] = useState({ show: false, index: null });
  const [chat, setChat] = useState({ show: false, text: null, ip: null });
  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    await httpReauest("GET", "/story", {}, {}).then(({ data }) => {
      setCategories(data?.data);
      data?.data?.map((e) => {
        if (e?.haveStory) {
          setcount(count + 1);
        }
      });
    });
  }

  function showModal(index) {
    setshow({ show: true, index: index });
  }

  function handleClose() {
    setshow({ show: false, index: null });
  }

  if (desktop) {
    return (
      <>
        {chat.show && (
          <Chat
            welcomeText={dealerData?.welcomeText}
            desktopText={chat.text}
            desktopIp={chat.ip}
            onClose={() => setChat({ show: false, text: null, ip: null })}
          />
        )}
        <Modal
          open={show.show}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="outline-none" style={style}>
            <StoryPage
              setChat={setChat}
              desktop
              show={show}
              setshow={setshow}
            />
          </div>
        </Modal>{" "}
        <Swiper className="mySiper flex justify-center" slidesPerView={9}>
          {categories?.map((e, i) => {
            return (
              <SwiperSlide key={i}>
                <span className="flex flex-col justify-start items-center">
                  <button
                    onClick={() => showModal(i)}
                    className="w-[60px] sm:w-[90px] h-[60px] sm:h-[90px] rounded-full border-2 p-0.5 overflow-hidden border-red-600 flex  justify-center items-center"
                  >
                    <img
                      style={{ pointerEvents: "none" }}
                      src={CDN_BASE_URL + e.cover}
                      className="object-cover w-full h-full rounded-full"
                      alt={e?.vehicle?.name}
                      title={e?.vehicle?.name}
                      loading="lazy"
                    />
                  </button>

                  <p className="text-center whitespace-nowrap pt-2">
                    {e?.name}
                  </p>
                </span>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </>
    );
  }
  return (
    <div className="flex gap-2 overflow-x-scroll scroll-hidden">
      {categories?.map((e, i) => {
        return (
          <span className="flex flex-col justify-start items-center">
            <Link
              to={"/story?index=" + i}
              className="w-[65px] sm:w-[90px] h-[65px] sm:h-[90px] rounded-full border-2 p-0.5 overflow-hidden border-red-600 flex  justify-center items-center"
            >
              <img
                src={CDN_BASE_URL + e.cover}
                style={{ pointerEvents: "none" }}
                className="object-cover rounded-full w-full h-full"
                alt={e?.name}
                title={e?.name}
              />
            </Link>

            <p className="text-center whitespace-nowrap pt-2">{e?.name}</p>
          </span>
        );
      })}
    </div>
  );
};

export default Storys;
